/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('easysearch_loaded', function(){
  const resultYMM = [];
  const productCollectionsHandle = document.querySelector('.easyCollections')?.getAttribute('data-collections').split(', ');
  if( typeof easysearch === 'object') {
    for (const property in easysearch.tree) {
      easysearch.tree[property].forEach( collectionLink => {
        if(collectionLink.indexOf('/collections/') > -1){
          if(productCollectionsHandle?.indexOf(collectionLink.replace('/collections/', '')) > -1){
            if(!resultYMM.includes(property)){
              resultYMM.push(property);
            }
          }
        }
      })
    } 
  }
  const container = document.querySelector('.easytabs-content-item[data-et-handle="tabs-fitment"] .easytabs-content-holder');
  resultYMM.forEach(el => {
    const newElement = document.createElement('span'); 
    newElement.textContent = el.replaceAll(',', ' ');
    newElement.style.display = 'block';
    container.append(newElement);
  })
});

document.addEventListener("DOMContentLoaded", (event) => {
  const btnCheckout = $('[action="/cart"] button[type="submit"]');
  if(typeof(BSS_B2B) !== 'undefined' && BSS_B2B.cpSettings) {
    if(btnCheckout) {
      btnCheckout.prop('disabled', true);
      let runCount = 0;
      document.addEventListener('bss_b2b_doneCheckCp', (e) => {
        if(runCount > 0) {
          btnCheckout.prop('disabled', false);
        }
        runCount++;
      });

      setTimeout(() => {
        btnCheckout.prop('disabled', false);
      }, 10000);
    }
    
    const formCart = document.querySelector('[action="/cart"]');
      if(formCart instanceof HTMLFormElement) {
        formCart.addEventListener('submit', (e) => {
           const cpList = BSS_B2B?.cart?.cpPricingList;
            if(cpList?.size) {
              console.log(`Blocked checkout by BSS`);
              e.preventDefault();
            }
        });
      }
  }
    if(window.location.pathname === '/cart' && typeof(BSS_B2B) !== 'undefined') {
      if(btnCheckout.length) {
        btnCheckout.click(function () {
          if(typeof(BSS_B2B) !== 'undefined') {
            const shopData = JSON.parse($('#bss-b2b-store-data').html())
            BSS_B2B.handleCartCheckoutBtn(shopData)
          }
        })
      }
  }
});
